import PropTypes from 'prop-types';

import useAppContext from '../../conf/AppContext';
import InfoLink from '../Links/Info';

// eslint-disable-next-line import/prefer-default-export
export function renderInfoLink(helpLink) {
  if (helpLink) {
    if (helpLink.indexOf('fuzzybet.atlassion.net/wiki') !== -1) {
      return <WikiLink href={helpLink} />;
    } else {
      return <small><InfoLink href={helpLink} iconClassName="icon--superscript" iconSize="2xs" /></small>;
    }
  }
  return null;
}


const propTypes = {
  href: PropTypes.string.isRequired,
};
/**
 * This is a wrapper around InfoLInk that is admin-only. This meant to link off to documentation at the
 * admin wiki so admins can get more information about what to do in a particular too/page.
 *
 * @param {object} props - props container
 * @param {string} props.href - an url to the admin wiki
 * @return {JSXElement}
 */
function WikiLink({href}) {
  const appContext = useAppContext();
  return (
    appContext.isPreview && (
      <small><InfoLink href={href} iconClassName="icon--superscript" iconSize="2xs" /></small>
    )
  );
}
WikiLink.propTypes = propTypes;
